/* eslint-disable no-unused-vars */
import React from "react";
import { Grid, TextField } from "@mui/material";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { StringUtils } from "../../utils/StringUtils";

export default function PDatePicker(props) {
  function formatDate(value) {
    if (value && value.$d) {
      /*var copiedDate = new Date(value.$d.getTime());
      var tzDifference = copiedDate.getTimezoneOffset();
      var offsetTime = new Date(
        copiedDate.getTime() - tzDifference * 60 * 1000
      );
      console.log("LG#", copiedDate, offsetTime.toISOString());
      value.$d = offsetTime;*/
    }
    return value;
  }
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DesktopDatePicker
        style={props.style}
        label={props.label}
        inputFormat="DD/MM/YYYY"
        value={formatDate(props.value)}
        onChange={(newValue) => {
          if (props.onChange) {
            props.onChange(newValue);
          }
        }}
        renderInput={(params) => (
          <TextField
            readonly={true}
            fullWidth={true}
            {...params}
            InputLabelProps={{ shrink: true }}
          />
        )}
      />
    </LocalizationProvider>
  );
}
